import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { NgxsModule } from '@ngxs/store';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { RatingModule } from '@shared/components/rating/rating.module';
import { SvgModule } from '@shared/components/svg/svg.module';
import { SearchInputModule } from '@shared/components/search-input/search-input.module';
import { LoaderModule } from '@shared/components/loader/loader.module';
import { FormatDigitsModule } from '@shared/pipes/format-digits/format-digits.module';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorPageMessageModule } from '@shared/components/error-page-message/error-page-message.module';
import { DeclensionWordModule } from '@shared/pipes/declension-word/declension-word.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HoverableSvgModule } from '@shared/components/hoverable-svg/hoverable-svg.module';
import { MultiSelectWithInputModule } from '@shared/components/multi-select-with-input/multi-select-with-input.module';
import { LongPressModule } from '@shared/directives/long-press/long-press.module';
import { MatMenuModule } from '@angular/material/menu';
import { CustomToolTipModule } from '@shared/directives/custom-tool-tip/custom-tool-tip.module';
import { SafeHtmlModule } from '@shared/pipes/safe-html/safe-html.module';
import { CatalogTableState } from './store/catalog-table.state';
import { DataMainComponent } from './components/main/data-main.component';
import { CatalogTableHeaderComponent } from './components/catalog-table-header/catalog-table-header.component';
import { CatalogTableComponent } from './components/catalog-table/catalog-table.component';
import { CatalogTableFilterComponent } from './components/catalog-table-filter/catalog-table-filter.component';
import { CatalogRoutingModule } from './catalog-routing.module';
import { DownloadButtonModule } from '../../shared/components/download-button/download-button.module';
import { MoreVertMenuModule } from '../../shared/components/more-vert-menu/more-vert-menu.module';
import { OrderingComponent } from './components/ordering/ordering.component';
import { RegistryExportComponent } from './components/registry-export/registry-export.component';
import { RegistryExportModalComponent } from './components/registry-export/registry-export-modal/registry-export-modal.component';

@NgModule({
  declarations: [
    DataMainComponent,
    CatalogTableHeaderComponent,
    CatalogTableComponent,
    CatalogTableFilterComponent,
    OrderingComponent,
    RegistryExportComponent,
    RegistryExportModalComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonToggleModule,
    MatInputModule,
    TranslateModule,
    MatTableModule,
    MatPaginatorModule,
    OverlayModule,
    MatRadioModule,
    MatListModule,
    MatCheckboxModule,
    MatButtonModule,
    NgxsModule.forFeature([CatalogTableState]),
    MatProgressSpinnerModule,
    MatCardModule,
    CatalogRoutingModule,
    SvgModule,
    DownloadButtonModule,
    MoreVertMenuModule,
    RatingModule,
    SearchInputModule,
    NgLetModule,
    LoaderModule,
    FormatDigitsModule,
    TableVirtualScrollModule,
    ReactiveFormsModule,
    ErrorPageMessageModule,
    DeclensionWordModule,
    MatTooltipModule,
    HoverableSvgModule,
    MultiSelectWithInputModule,
    FormsModule,
    LongPressModule,
    MatMenuModule,
    CustomToolTipModule,
    SafeHtmlModule
  ]
})
export class CatalogDataModule {}
